<div class="success-modal">
    <p class="mt-2">{{message}}</p>

    <div class="close-btn-row">
        <button pButton label="Close" class="close-btn" (click)="close()" [routerLink]="route"></button>
    </div>
</div>